import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import TextField from '@material-ui/core/TextField';
import { Redirect } from 'react-router-dom';

import { Button } from '@mui';
import DotmapsLoader from '@components/shared/dotmaps-loader';
import Soc2ValidationDisplay from './soc2-validation-display';
import UnstyledHeading from '@components/shared/unstyled-heading';

import { useSoc2PasswordValidation } from './hooks';

import '../layouts/not-authenticated/not-authenticated.scss';
import styles from './password-create.scss';

const CREATE_PASSWORD_HEADER_ID = 'auth-create-password';

const PasswordCreate = ({
  formChange,
  formData,
  formSubmit,
  isOnboarding,
  passwordErrorText,
  fullname,
  password,
  passwordTwo
}) => {
  const passwordCreateHeaderText = isOnboarding ? 'Complete your account' : 'Create new password';
  const submitLabel = isOnboarding ? 'CREATE ACCOUNT' : 'CONFIRM NEW PASSWORD';
  const {
    soc2Active,
    soc2Valid,
    validationTypes
  } = useSoc2PasswordValidation(formData, password);

  const submitDisabled = (isOnboarding && !fullname) || !password || !passwordTwo || (soc2Active && !soc2Valid);

  return (
    <main data-testid="password-create" aria-labelledby={CREATE_PASSWORD_HEADER_ID}>
      <UnstyledHeading rank={2} id={CREATE_PASSWORD_HEADER_ID} styleName="auth-heading">
        { passwordCreateHeaderText }
      </UnstyledHeading>
      { formData?.status ?
        <Fragment>
          {formData.status === 200 ?
            <form onSubmit={formSubmit}>
              {isOnboarding &&
                <div styleName="not-authenticated-form-text-field">
                  <TextField
                    fullWidth
                    id="fullname"
                    name="fullname"
                    onChange={formChange}
                    label="Full name"
                  />
                </div>
              }
              <div styleName="not-authenticated-form-text-field">
                <TextField
                  fullWidth
                  id="password"
                  name="password"
                  type="password"
                  onChange={formChange}
                  label="New password"
                />
              </div>
              <div styleName="not-authenticated-form-text-field">
                <TextField
                  fullWidth
                  id="passwordTwo"
                  name="passwordTwo"
                  type="password"
                  onChange={formChange}
                  errorText={passwordErrorText}
                  error={passwordErrorText?.length > 0}
                  helperText={passwordErrorText}
                  label="Confirm password"
                />
              </div>
              { soc2Active &&
                <Soc2ValidationDisplay {...validationTypes} />
              }
              <div>
                <Button
                  color="primary"
                  disabled={submitDisabled}
                  fullWidth
                  type="submit"
                  variant="contained"
                >
                  {submitLabel}
                </Button>
              </div>
            </form> :
            <div>
              <Redirect to="/auth/invalid"/>
            </div>
          }
        </Fragment> :
        <div className={styles.loader}>
          <DotmapsLoader />
        </div>
      }
    </main>
  );
};

PasswordCreate.propTypes = {
  formChange: PropTypes.func,
  formData: PropTypes.object,
  formSubmit: PropTypes.func,
  fullname: PropTypes.string,
  isOnboarding: PropTypes.bool,
  password: PropTypes.string,
  passwordErrorText: PropTypes.node,
  passwordTwo: PropTypes.string
};

export default PasswordCreate;
